const DELEO_STATUS_MAPPING: Record<string, { text: string; description: string }> = {
  REQUEST_ORDER: { text: 'Order Requested', description: '주문요청' },
  REQUEST_OUTBOUND: { text: 'Request for delivery', description: '출고요청' },
  ING_OUTBOUND: { text: 'In process of shipment', description: '출고처리중' },
  COMPLETE_OUTBOUND: { text: 'Release Completed', description: '출고완료' },
  ING_DELIVERY: { text: 'Shipping', description: '배송중' },
  COMPLETE_DELIVERY: { text: 'Delivery completed', description: '배송 완료' },
  COMPLETE_CANCEL: { text: 'Cancelled', description: '취소완료' },
};

export const getStatusText = (name: string) => {
  return DELEO_STATUS_MAPPING[name]?.text || '';
};

export const getStatusDescription = (name: string) => {
  return DELEO_STATUS_MAPPING[name]?.description || '';
};
